import React, { useState } from 'react';
import { Printer } from 'lucide-react';
import TinnitogramDataEntry from './tinnitogram/TinnitogramDataEntry';
import TinnitogramReportModal from './tinnitogram/TinnitogramReportModal';

/**
 * TinnitusPanel — top-level Tinnitogram tab.
 *
 * Rebuilt on 2026-02-18 to replace the flat CFField grid with a
 * three-subtest editor (Pitch Match · Loudness Match · Masking Curve)
 * that includes interactive graphs with two-way sync to their tables,
 * auto-derived summary + interpretation, and a print-ready A4 report
 * matching the Audinexa reference asset.
 */
const TinnitusPanel = ({ data, onChange, patient, sessionId, audiologistName }) => {
  const [showReport, setShowReport] = useState(false);
  return (
    <div className="flex-1 flex flex-col min-h-0" data-testid="tinnitogram-tab-root">
      <div className="flex items-center justify-between bg-slate-100 border-b border-slate-300 px-3 py-1 flex-shrink-0">
        <div className="text-xs font-semibold text-slate-700 uppercase">
          Tinnitogram · Pitch Match | Loudness Match | Masking Curve
        </div>
        <button type="button" onClick={() => setShowReport(true)}
          data-testid="tin-print-report-btn"
          className="inline-flex items-center gap-1 px-2.5 py-1 text-[11px] font-bold bg-slate-800 hover:bg-slate-900 text-white rounded shadow-sm"
          title="Preview + print the standalone Tinnitogram report (A4)">
          <Printer size={12} /> Print Tinnitogram Report
        </button>
      </div>
      <TinnitogramDataEntry data={data} onChange={onChange} audiologistName={audiologistName} />
      {showReport && (
        <TinnitogramReportModal data={data} patient={patient} sessionId={sessionId} onClose={() => setShowReport(false)} />
      )}
    </div>
  );
};

export default TinnitusPanel;
